var React = require('react');

function IconPlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.5,0,17,8H0Z","transform":"translate(8) rotate(90)","fill":"#fff"}));
}

IconPlay.defaultProps = {"width":"8","height":"17","viewBox":"0 0 8 17"};

module.exports = IconPlay;

IconPlay.default = IconPlay;
